module.exports = __webpack_public_path__ + "img/trofi-poster-image.7034a34d.jpg";